import React, { useState } from 'react';
import axios from 'axios';
import { PaystackButton } from 'react-paystack';
import config from '../config/config';

const PaymentModal = ({ postId, price, onClose, walletBalance }) => {
  const [paymentMethod, setPaymentMethod] = useState(''); // Dropdown selection
  const [showLoading, setShowLoading] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastType, setToastType] = useState('');

  const token = localStorage.getItem('token');

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  };

  const paystackConfig = {
    reference: (new Date()).getTime().toString(),
    email: 'user@example.com',
    amount: price * 100, // Amount in kobo
    publicKey: 'pk_test_6d954b11ef91c1d7a8911f46a866de5f37a5771a',
    onSuccess: (reference) => {
      console.log('Paystack success:', reference);
      handlePaymentSuccess('paystack', reference.reference);
    },
    onClose: () => console.log('Payment window closed'),
  };

  const handleNowPayments = async () => {
    const requestData = {
      price_amount: price,
      price_currency: "usd",
      pay_currency: "btc",
      ipn_callback_url: "https://yourwebsite.com/callback",
      order_id: `${postId}-${(new Date()).getTime()}`,
      order_description: `Subscription for post ID ${postId}`,
    };

    try {
      const response = await axios.post(
        'https://api-sandbox.nowpayments.io/v1/payment',
        requestData,
        {
          headers: {
            'x-api-key': '11H5KAD-1NC4A54-NG25HG0-Y78N8BS',
            'Content-Type': 'application/json',
          }
        }
      );

      if (response.data && response.data.payment_id) {
        const { payment_id, payment_url } = response.data;
        window.open(payment_url, '_blank');

        // Polling or checking for payment status
        const interval = setInterval(async () => {
          try {
            const statusResponse = await axios.get(
              `https://api-sandbox.nowpayments.io/v1/payment/${payment_id}`,
              {
                headers: {
                  'x-api-key': '11H5KAD-1NC4A54-NG25HG0-Y78N8BS',
                },
              }
            );            
            if (statusResponse.data.status === 'paid') {
              clearInterval(interval);
              handlePaymentSuccess('nowpayment', payment_id);
            }
          } catch (error) {
            clearInterval(interval);
            setToastMessage('Error checking payment status');
            setToastType('error');
            setTimeout(() => setToastMessage(''), 3000);
          }
        }, 5000); // Poll every 5 seconds

      } else {
        setToastMessage('Failed to initiate NowPayments transaction.');
        setToastType('error');
        setTimeout(() => setToastMessage(''), 3000);
      }
    } catch (error) {
      setToastMessage('Error initiating NowPayments transaction');
      setToastType('error');
      setTimeout(() => setToastMessage(''), 3000);
    }
  };

const handlePaymentSuccess = async (paymentMethod = '', transaction_id = '') => {
  if (!paymentMethod) {
    setToastMessage('Payment method is required.');
    setToastType('error');
    setTimeout(() => setToastMessage(''), 3000);
    return;
  }

  setShowLoading(true);
  try {
    const response = await axios.post(`${config.baseURL}/purchase-post`, {
      post_id: postId,
      payment_method: paymentMethod, // This will include "userwallet"
      transaction_id: transaction_id,
    }, { headers });

    if (response.status === 200) {
      setToastMessage('Post purchased successfully.');
      setToastType('success');
      setTimeout(() => {
        setToastMessage('');
        onClose(); // Close the modal
        window.location.reload(); // Refresh the page
      }, 3000);
    } else {
      throw new Error('Subscription failed.');
    }
  } catch (error) {
    console.error('Error during payment success handling:', error);
    setToastMessage('Payment failed. Please try again.');
    setToastType('error');
    setTimeout(() => setToastMessage(''), 3000);
  } finally {
    setShowLoading(false);
  }
};

const handlePayNowClick = () => {
  document.body.classList.add('payment-processing'); // Add class on button click 
  if (paymentMethod === 'paystack') {
    // Simulate Paystack button click
    const paystackButton = document.querySelector('.paystack-button');
    if (paystackButton) {
      paystackButton.click();
    }
  } else if (paymentMethod === 'nowpayment') {
    handleNowPayments(); // Handle NowPayments click
  } else if (paymentMethod === 'userwallet') {
    // Check if wallet balance is sufficient
    if (walletBalance >= price) {
      handlePaymentSuccess('userwallet'); // Proceed with wallet payment
    } else {
      setToastMessage('Insufficient wallet balance to complete the purchase.');
      setToastType('error');
      setTimeout(() => setToastMessage(''), 3000);
    }
  }
};

  return (
    <>
      <div className="modal-overlay show" onClick={onClose} />
      <div className="modal paymentModal fade show" tabIndex="-1" aria-labelledby="paymentModalLabel" aria-hidden="true" style={{ display: 'block' }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="paymentModalLabel">Choose Payment Method</h5>
              <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <p>Select your preferred payment method to proceed with the subscription.</p>
              <select
                className="form-select"
                value={paymentMethod}
                onChange={(e) => setPaymentMethod(e.target.value)}
              >
                <option value="">Select a payment method</option>
                <option value="paystack">Paystack</option>
                <option value="nowpayment">NowPayments</option>
                 
                    <option value="userwallet">Wallet Balance </option>
                  {/* Only render if walletBalance is greater than 0 */}
              </select>
              {/* {showLoading && <div>Loading...</div>}  */}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary send_btn" onClick={handlePayNowClick}>
                Pay Now
              </button>
              <PaystackButton
                {...paystackConfig}
                text="Pay with Paystack"
                className="d-none paystack-button" // Hidden by default
              />
              <button type="button" className="btn btn-secondary send_btn" onClick={onClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      {toastMessage && (
        <div className={`toastmessage ${toastType} ${toastMessage ? 'show' : ''}`}>
          {toastMessage}
        </div>
      )}
    </>
  );
};

export default PaymentModal;
